import axios from 'axios'
import { store } from '../utility/createStore'
import { refreshTokens } from '../actions/users'
import { invokeNotification } from '../actions/global-notification'
import { toggleModal } from '../actions/modal'
import { signOut } from '../actions/users'

const baseUrl = process.env.REACT_APP_API_URL

export const apiNotification = params => {
  store.dispatch(invokeNotification(params))
}

// adds headers to all requests if they exists
axios.interceptors.request.use(
  config => {
    const tokens = store.getState().users.tokens
    const addTokens = config.url.includes(baseUrl)

    if (tokens && addTokens) {
      config.headers['Authorization'] = 'Bearer ' + tokens.access_token
    }

    return config
  },
  error => Promise.reject(error)
)

// handles token refreshing if they are expired
axios.interceptors.response.use(
  response => response,
  error => {
    const refresh_token = store.getState().users.tokens.refresh_token

    const originalRequest = error.config
    const body = error.response.data

    // intercepts request if token is expired
    if (
      error.response.status === 401 &&
      body.message === 'Token expired' &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true

      // redirect to login if not logged in
      if (!store.getState().users.signedIn || !refresh_token) {
        const currentLocation = store.getState().router.location.pathname

        store.dispatch(toggleModal(true, currentLocation))
        return Promise.reject()
      }

      // make a refresh request for tokens
      // put refreshed tokens to store
      return axios
        .post(`${baseUrl}auth`, {
          refresh_token,
          action: 'refresh'
        })
        .then(({ data }) => {
          store.dispatch(
            refreshTokens({
              access_token: data.tokens.access_token,
              id_token: data.tokens.id_token,
              refresh_token: data.tokens.refresh_token
            })
          )

          axios.defaults.headers.common['Authorization'] =
            'Bearer ' + data.access_token
          originalRequest.headers['Authorization'] = data.access_token

          // redo original request
          return axios(originalRequest)
        })
        .catch(() => {
          store.dispatch(signOut())
          store.dispatch(invokeNotification('registration.invalid_login'))
        })
    }

    // user is logged out
    if (
      error.response.status === 401 &&
      (body.message === 'Token renew failed' ||
        body.message === 'No auth token')
    ) {
      const currentLocation = store.getState().router.location.pathname

      store.dispatch(toggleModal(true, currentLocation))
    }

    // reject all else scenarios
    return Promise.reject(error)
  }
)

/*  baseurl ends to /
*   using GET and POST url should be in like path/to/; not /path/to/

/*  queryparams should be an object
*   {param: value}
*   evaluating to url?param=value
*/
export const GET = (url, queryParams = {}, useBaseUrl = true) => {
  const urlPrefix = useBaseUrl ? baseUrl : ''

  return axios.get(urlPrefix + url, {
    params: queryParams
  })
}

export const DELETE = (url, queryParams = {}, useBaseUrl = true) => {
  const urlPrefix = useBaseUrl ? baseUrl : ''

  return axios.delete(urlPrefix + url, {
    params: queryParams
  })
}

/*
 *   body should be an object
 */
export const POST = (url, body, useBaseUrl = true) => {
  const urlPrefix = useBaseUrl ? baseUrl : ''

  return axios.post(urlPrefix + url, body)
}



/*
 *   body should be an object
 */
export const PUT = (url, body, useBaseUrl = true) => {
  const urlPrefix = useBaseUrl ? baseUrl : ''

  return axios.put(urlPrefix + url, body)
}
